export default "__VITE_ASSET__Bjqak8VZ__"